import { motion } from "framer-motion";
import { RevealLines, Reveal } from "./Reveal";

// Shared hero band for inner pages with an image side and masked-reveal heading.
export default function PageHeader({ overline, titleLines, subtitle, image, imageAlt, testId = "page-header" }) {
  return (
    <section data-testid={testId} className="relative overflow-hidden pt-32 md:pt-40 pb-16 md:pb-20">
      <div className="mx-auto grid max-w-[1400px] items-center gap-10 px-5 md:grid-cols-12 md:px-10">
        <div className="md:col-span-7">
          <motion.span initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.9, delay: 0.1 }} className="overline text-gold">
            {overline}
          </motion.span>
          <h1 className="mt-6 font-serif text-5xl md:text-7xl font-light leading-[0.95] tracking-tight text-navy">
            <RevealLines lines={titleLines} delay={0.3} />
          </h1>
          {subtitle && (
            <Reveal delay={0.9} className="mt-7 max-w-xl">
              <p className="text-base md:text-lg font-light leading-relaxed text-navy/70">{subtitle}</p>
            </Reveal>
          )}
        </div>
        {image && (
          <div className="md:col-span-5">
            <motion.div
              initial={{ opacity: 0, scale: 1.05 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1], delay: 0.4 }}
              className="relative aspect-[4/5] w-full overflow-hidden rounded-sm border border-gold/40"
            >
              <img src={image} alt={imageAlt} className="h-full w-full object-cover" />
            </motion.div>
          </div>
        )}
      </div>
    </section>
  );
}
